import { Injectable, signal } from '@angular/core';
import { NavBadgeCounts } from '../models';

export type NavKey = keyof NavBadgeCounts;

@Injectable({ providedIn: 'root' })
export class NavBadgeService {
  private readonly _counts = signal<NavBadgeCounts>({
    candidates: 0,
    backfill: 0,
    marketing: 0,
    jobs: 0,
  });

  // "Unseen" markers — drive a red dot on the nav tab, independent of the count.
  private readonly _unseen = signal<Record<NavKey, boolean>>({
    candidates: false,
    backfill: false,
    marketing: false,
    jobs: false,
  });

  readonly counts = this._counts.asReadonly();
  readonly unseen = this._unseen.asReadonly();

  setCounts(counts: Partial<NavBadgeCounts>): void {
    this._counts.update(current => ({ ...current, ...counts }));
  }

  /** Flag a tab as having new, unseen activity (shows a red dot). */
  markUnseen(key: NavKey): void {
    this._unseen.update(current => ({ ...current, [key]: true }));
  }

  /** Clear the unseen marker — typically when the user visits the tab. */
  clearUnseen(key: NavKey): void {
    this._unseen.update(current => ({ ...current, [key]: false }));
  }
}
